import { Form, Formik } from 'formik'
import { convertDateFormatCalendar } from '../../utility/genricFunction'
import './fromToDatePicker.scss'
import FromToCalenderPicker from '../form-to-calender-picker/FromToCalenderPicker'
import { useDispatch } from 'react-redux'
import { setDateFrom, setDateTo } from '../../store/slice/inquiry/inquiry.slice'

function FromToDatePicker() {
    const initialValues = {
        dateForFrom: '',
        dateForTo: '',
    }

    const dispatch = useDispatch();

    
  const handleDateChange = (name, value) => {
    const convertedDate = convertDateFormatCalendar(value); // Assuming convertDateFormatCalendar function is defined

    if (name === 'dateForFrom') {
      dispatch(setDateFrom(convertedDate));
    } else {
      dispatch(setDateTo(convertedDate));
    }
  };

    return (
        <Formik
            initialValues={initialValues}
        >{({ values }) => (
            <Form>
                <div className='from-to-calender-wrapper'>
                    <FromToCalenderPicker
                        name='dateForFrom'
                        holder="From"
                        type={'date'}
                        showIcon={false}
                        dateFrom
                        value={values.dateForFrom ? values.dateForFrom : ""}
                        onChange={(values) => handleDateChange('dateForFrom', values)}
                    />

                    <FromToCalenderPicker
                        name='dateForTo'
                        holder="To"
                        type={'date'}
                        showIcon={false}
                        dateTo
                        value={values.dateForTo ? values.dateForTo : ""}
                        onChange={(values) => handleDateChange('dateForTo', values)}
                    />


                </div>
            </Form>
        )}
        </Formik>
    )
}

export default FromToDatePicker
